(function tabbedcontentScript($, Drupal) {
  Drupal.behaviors.tabbedcontent = {
    attach(context) {
      const tab = $('.tabbed-content__tab', context);
      const pages = document.getElementsByClassName('tabbed-content__page');

      // Handle click events on tabs.
      tab.click((e) => {
        // Prevent default event and blur focus from tab.
        e.preventDefault();
        $(e.target).blur();

        const pageID = $(e.target).data('tab-no');
        let siblingPage;

        // Loop over all the tabbed-content pages on the page.
        // Remove active classes and define the sibling page that matches our clicked tab.
        for (let i = 0; i < pages.length; i++) {
          $(pages[i]).removeClass('tabbed-content__page--active');
          if ($(pages[i]).data('page') === pageID) {
            siblingPage = $(pages[i]);
          }
        }
        // Remove any active tab classes.
        tab.removeClass('tabbed-content__tab--active');

        // Assign active classes to current tab and sibling page.
        $(e.target).addClass('tabbed-content__tab--active');
        siblingPage.addClass('tabbed-content__page--active');
      });
    },
  };
}(jQuery, Drupal));
